<template>
<div class="main" >
    <div>
        <DiamondQuizTitle @closePage="emitclosePage"/>
    </div>

    <div>
        <DiamondQuizDiamondMessage message="What diamond shapes do you prefer?"/>
    </div>

    <div class="wraper mt-3">
        <div class="shape_box" :class="{ 'active-shape': selectedShapes.includes(shape.name) }" @click="toggleShapeSelection(shape.name)" v-for="(shape, index) in shapes" :key="index">
            <div class="images">
                <img :src="shape.src" :alt="shape.alt" width="64" height="64" />
            </div>
            <div class="shape_name">{{ shape.name }}</div>
            <div class="tag">{{ shape.tag }}</div>
        </div>
    </div>

    <div>
        <div class="buttons">
            <button  class="button1 text-center" @click="goToNextPage" :disabled="selectedShapes.length > 0">
                <span>Not Sure</span>
            </button >
            <div class="button text-center" @click="goToNextPage">
                <span>proceed</span>
            </div>
        </div>
        <DiamondQuizFooter/>
    </div>    
</div>
</template>

<script setup>
import { diamondQuizStore } from '@/stores/diamond_quiz/diamond_quiz';
const store = diamondQuizStore()

const shapes = [
    { src: '/shapes/round.jpg', alt: 'Round Cut Diamonds', name: 'Round', tag: 'Most Purchased' },
    { src: '/shapes/oval.jpg', alt: 'Oval Cut Diamonds', name: 'Oval', tag: 'Trendiest' },
    { src: '/shapes/marquise.jpg', alt: 'Marquise Cut Diamonds', name: 'Marquise', tag: 'Looks Biggest' },
    { src: '/shapes/pear.jpg', alt: 'Pear Cut Diamonds', name: 'Pear', tag: 'Budget Pick' },
    { src: '/shapes/radiant.jpg', alt: 'Radiant Cut Diamonds', name: 'Radiant', tag: 'Sparkiest' },
    { src: '/shapes/princess.jpg', alt: 'Princess Cut Diamonds', name: 'Princess', tag: 'Sparkiest' },
    { src: '/shapes/emerald.jpg', alt: 'Emerald Cut Diamonds', name: 'Emerald', tag: 'Sparkiest' },
    { src: '/shapes/heart.jpg', alt: 'Heart Cut Diamonds', name: 'Heart', tag: 'Sparkiest' },
    { src: '/shapes/asscher.jpg', alt: 'Asscher Cut Diamonds', name: 'Asscher', tag: 'Sparkiest' },
    { src: '/shapes/cushion.jpg', alt: 'Cushion Cut Diamonds', name: 'Cushion', tag: 'Sparkiest' }
];

const selectedShapes = ref([]);

const toggleShapeSelection = (shapeName) => {
    if (selectedShapes.value.includes(shapeName)) {
        selectedShapes.value = selectedShapes.value.filter(shape => shape !== shapeName); 
    } else {
        selectedShapes.value.push(shapeName);
    }
    const selectedShapesString = selectedShapes.value.join(',');
    store.setShape(selectedShapesString);
};

const emit = defineEmits(['close'])

const goToNextPage = () => {
    store.setNextPage()
}

const emitclosePage = () => {
    emit('close')
}



onMounted(() => {
    const storedShapes = store.getShape;
    selectedShapes.value = storedShapes ? storedShapes.split(',') : [];
});


</script>

<style scoped>
/* .main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90vh;
    overflow: auto;
    overflow-x: hidden;
} */

.largesvg {
    transform: scale(1.3);
}
.content {
    display: flex;
    justify-content: center;
    align-items: center;
}
.dialog_box {
    font-size: 18px;
    font-style: italic;
    color: #405955;
    border: 1px solid var(--green);
    border-radius: 4px;
    padding: 10px;
}
.wraper{
    display: flex;
    flex-wrap: wrap;
    gap: 20px 16px;
    justify-content: center;
    margin-bottom: 3%;
    /* width: 100%; */
    padding: 0 20px;
    max-width: 700px;
    margin: auto;
}

.shape_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px;
    border: 1px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
    width: 18%;
}

.shape_box.active-shape {
    background-color: #668b8419; 
    border: 1px solid var(--green); 
}

.error-box{
    display: flex;
    justify-content: center;
    align-items: center;
    color: red;
    min-height: 25px;
}

.images {
    margin-bottom: 12px;
}

.shape_name {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 2px;
    color: #606060;
    margin-bottom: 12px;
    text-transform: uppercase;
}

.tag {
    font-size: 12px;
    font-weight: 500;
    font-style: italic;
    color: #909090;
    text-align: center;
}

.buttons {
    display: flex;
    margin: 0 10%;
    padding: 2% 0;
    
}

.button {
    padding: 14px 30px;
    border: 1.5px solid var(--green);
    border-radius: 4px;
    width: 100%;
    background: var(--green);
    cursor: pointer;
}

.button1 {
    padding: 14px 30px;
    border: 1.5px solid #212529;
    border-radius: 4px;
    width: 100%;
    margin-right: 16px;
    cursor: pointer;
    background:transparent;
}

button:disabled {
    pointer-events: none;
    opacity: 0.5;
}

.button span {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 1.4px;
}

.button1 span {
    font-size: 14px;
    font-weight: 700;
    color: #212529;
    text-transform: uppercase;
    letter-spacing: 1.4px;
}

.close {
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
}
.back {
    position: absolute;
    top: 12px;
    left: 12px;
}

.largeBack {
    transform: scale(1.5)
}

@media(max-width:992px){
    .content img {
        width: 100px;
        height: 100px;
    }
    .dialog_box {
        font-size: 16px;
    }

    .shape_box {
        width: 29%;
    }
    
}

@media(max-width:768px) {
    .content img {
        width: 80px;
        height: 80px;
    }

    .dialog_box {
        font-size: 14px;
    }

    .buttons {
        margin:  0 2%;
    }

    .button {
        max-width: 100%;
        /* padding: 14px 30px; */
    }

    .shape_name {
        margin-bottom: 4px;
        letter-spacing: 1.5px;
    }

    .images img {
        width: 32px;
        height: 32px;
    }

    .wraper {
        margin-top: 15px;
        padding: 1%;
    }

    .button, .button1 {
        padding: 10px 15px;
    }

    .shape_box{
        min-height: 125px;
    }
    .main {
        height: auto;
    }
}
</style>
